import { signalStore } from '@ngrx/signals';
import { withUser } from './user/user.index';

export const SignalStore = signalStore({ providedIn: 'root' }, withUser());
